import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  GET_DINER_CHAT_DATA_ADMIN,
  GET_EVENT_CHAT_DATA_ADMIN,
  GET_ORDER_CHAT_DATA_ADMIN,
  GET_VENDOR_CHAT_DATA_ADMIN
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";



export const get_chat_data_admin = (token, type,startDate,endDate) => async (
  dispatch
) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let getChatData = await axios.get(
      `${serverApi}/chat`,
      {
        params: { type: type, startDate :startDate, endDate:endDate },
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (getChatData.status === 200) {
      if (type === "DINER") {
        dispatch({
          type: GET_DINER_CHAT_DATA_ADMIN,
          payload: getChatData.data,
        });
      }
      if (type === "ORDER") {
        dispatch({
          type: GET_ORDER_CHAT_DATA_ADMIN,
          payload: getChatData.data,
        });
      }
      if (type === "EVENT") {
        dispatch({
          type: GET_EVENT_CHAT_DATA_ADMIN,
          payload: getChatData.data,
        });
      }
      if (type === "GENERAL") {
        dispatch({
          type: GET_VENDOR_CHAT_DATA_ADMIN,
          payload: getChatData.data,
        });
      }
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

